import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import { AbilityContext } from 'context/Can';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
// import defineAbility from 'config/defineAbility';

import { defineAbility } from '@casl/ability';
import { selectUserYearBookLastDate, selectUserYearIsSequenceTestimonials } from 'store/slices/authSlice';
import moment from 'moment';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    const yearBook = useSelector((state) => state.auth.data.yearBook);
    const user = useSelector((state) => state.auth.data);
    const isSequenceTestimonial = useSelector(selectUserYearIsSequenceTestimonials);
    const yearBookLastDate = useSelector(selectUserYearBookLastDate);

    const isLastDateSmaller = moment(yearBookLastDate).isSameOrBefore(new Date());

    const ability = defineAbility((can) => {
        console.log(user.role);

        if (!isSequenceTestimonial) can('all', 'common');

        can('all', 'logout');
        /* eslint-disable spaced-comment */
        //student role 1 all common page and conditional page
        if (user.role === '1' || user.role === '2' || user.role === '3') {
            if (user?.studentLevel === '1' && !isSequenceTestimonial) {
                if (!isLastDateSmaller) {
                    if (yearBook?.includeGallery) can('all', 'includeGallery');
                    if (yearBook?.includePoll) can('all', 'includePoll');
                    if (yearBook?.profileQuestions) can('all', 'profileQuestions');
                    if (yearBook?.collagePhoto) can('all', 'collagePhoto');
                }
            }
            if (yearBook?.includeTestimonials) can('all', 'includeTestimonials');
        }

        if (user.role === '2' || user.role === '3') {
            if (!isSequenceTestimonial) {
                can('all', 'coordinatorDetails');
            }
        }

        if (user.role === '3' || user.role === '4') {
            if (user?.studentLevel === '1' && !isSequenceTestimonial) {
                can('all', 'studentList');
                can('all', 'commonPageData');
            }
        }

        // can('create', 'thing');
        // can('update', 'thing', { userId: 3 });
        // can('delete', 'thing', { userId: 3 });
    });

    return (
        <StyledEngineProvider injectFirst>
            <AbilityContext.Provider value={ability}>
                <ThemeProvider theme={themes(customization)}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Routes />
                    </NavigationScroll>
                </ThemeProvider>
            </AbilityContext.Provider>
        </StyledEngineProvider>
    );
};

export default App;
